// src\themes\lino\layouts\default.tsx
import { ReactNode } from 'react';
import Header from '../elements/Header/Header';
import Footer from '../elements/footer/Footer';
import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
import SupportWidget from '@/themes/tolica/components/AdminSupportButton';
import { getSettings } from '@/core/lib/api/account/settings';
import MainContentWrapper from '../elements/Header/MainContentWrapper';

export default async function MainLayout({
    children,
}: Readonly<{
    children: ReactNode;
}>) {
    const settingsRes = await getSettings().catch(() => null);
    const isSupportActive = settingsRes?.data?.support_widget_active !== 'deactive';
    return (
        <>
            <OrganizationSchema />
            <Header />
            <main className="flex flex-col bg-primary-50 min-h-[calc(100vh-72px)]">
                <MainContentWrapper>{children}</MainContentWrapper>
            </main>
            {/* <SupportWidget active={isSupportActive} /> */}
            <Footer />
        </>
    );
}